
<div class="dialog-content-wrapper m-0">
  <dialog-header headerClass="primary" 
                 title="{{title | translate}}">
  </dialog-header>
  
  <div class="pt-8 px-16">
    <form [formGroup]="form">
      <div>
        <mat-form-field fxFlex>
          <input matInput
                 placeholder="{{'DIALOG.CREATEPOINT.NAME' | translate}}"
                 formControlName="name"
                 required
                 cdkFocusInitial>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field fxFlex>
          <input matInput
                 placeholder="{{'DIALOG.CREATEPOINT.ADDRESS' | translate}}"
                 formControlName="address"
                 required
                 [matAutocomplete]="addressAutocomplete"
                 (input)="addressChanged($event.target.value)">
          <mat-autocomplete #addressAutocomplete="matAutocomplete" (optionSelected)="addressSearchResultSelected($event.option.value)">
            <mat-option *ngFor="let searchResult of addressSearchResults" [value]="searchResult">
              {{searchResult.description}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <button mat-raised-button type="button" class='ml-20 my-20' (click)='findCoordinate()'>{{'DIALOG.CREATEPOINT.FINDCOORDINATE' | translate}}</button>
      </div>

      <div fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">
        <mat-form-field fxFlex='40'>
          <input matInput
                 type='number'
                 class='no-spinners'
                 placeholder="{{'DIALOG.CREATEPOINT.LATITUDE' | translate}}"
                 formControlName="lat"
                 required
                 (keyup)="updateLat()">
          <mat-error *ngIf="form.get('lat').hasError('min')">{{'DIALOG.CREATEPOINT.ERROR.MIN' | translate:latitudeErrorParam}}</mat-error>
          <mat-error *ngIf="form.get('lat').hasError('max')">{{'DIALOG.CREATEPOINT.ERROR.MAX' | translate:latitudeErrorParam}}</mat-error>
        </mat-form-field>

        <mat-form-field fxFlex='40'>
          <input matInput
                 type='number'
                 class='no-spinners'
                 placeholder="{{'DIALOG.CREATEPOINT.LONGITUDE' | translate}}"
                 formControlName="lon"
                 required
                 (keyup)="updateLon()">
          <mat-error *ngIf="form.get('lat').hasError('min')">{{'DIALOG.CREATEPOINT.ERROR.MIN' | translate:longitudeErrorParam}}</mat-error>
          <mat-error *ngIf="form.get('lat').hasError('max')">{{'DIALOG.CREATEPOINT.ERROR.MAX' | translate:longitudeErrorParam}}</mat-error>
        </mat-form-field>

        <button mat-raised-button type="button" class='my-20' (click)='findAddress()'>{{'DIALOG.CREATEPOINT.FINDADDRESS' | translate}}</button>
      </div>

      <agm-map #map
               [zoom]="zoom"
               [latitude]="lat"
               [longitude]="lon"
               (mapReady)="mapReady($event)"
               (zoomChange)="zoomChanged($event)">

        <agm-marker [latitude]="lat"
                    [longitude]="lon"
                    [markerDraggable]="true"
                    (dragEnd)="updatePosition($event)">
        </agm-marker>

      </agm-map>

      <div class='py-8' fxLayout="row" fxLayoutAlign="end center">
        <button mat-raised-button
                color="accent"
                [disabled] = "dataSaver.isProcessing()"
                (click)='checkAndSave()'>{{buttonName | translate}}
        </button>
      </div>
    </form>
  </div>
</div>
